const _isDestroyed = Symbol('isDestroyed');

export class Destroyable {
	constructor() {
		this[_isDestroyed] = false;
	}
	destroy() {
		this[_isDestroyed] = true;
	}
	get isDestroyed() {
		return this[_isDestroyed];
	}
}